export const ScheduleDetails = ({children, weeklyView}) => {
    return (
        <div className={`middle-up row ${weeklyView? "pb-2" : "pb-3"}`}>
            <div className="schedule-details col-12">
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
};